/// <reference path="../../../../node_modules/@types/datatables.net/index.d.ts" />
/// <reference path="../../../../node_modules/@types/jquery/index.d.ts" />

import { Component, NgZone, OnDestroy, OnInit } from "@angular/core";
import { HttpEventType, HttpParams, HttpResponse } from "@angular/common/http";
import { User } from "../models/user.model";
import { UserService } from "../services/user.service";
import { Alert } from "../../shared/alert.model";
import { getAlertMessage } from "../../shared/api-loaders";
import { ResourcePermissions } from "../../shared/resource-permissions.model";
import { firstValueFrom, Observable, Subscription } from "rxjs";
import { MessageService } from "../../shared/message.service";
import { ModalService } from "../../shared/modal.service";
import { MessageType } from "../../shared/messageType";
import { PaginationService } from "../services/pagination.service";
import { Router } from "@angular/router";
import { Select2Option } from "../../shared/select2-option";
import { UserListActionsModalComponent } from "../user-list/user-list.component";
import { UserDetailOptionsFacility } from "../models/user-detail-options";
import { SecurityService } from "../../shared/security.service";
import { UserDetailService } from "../services/user-detail.service";
import { ConfigurationService } from '../../ect-feature/services/configuration.service';
import { CustomerService } from '../../ect-feature/services/customer.service';
import { UsersExportDialogComponent } from "../users-export/users-export-dialog.component";
import { getDownloadFileName } from "../../shared/StringHelper";
import * as fileSaver from "file-saver";
import { UserExportRequest } from "../models/UserExportRequest";
import { ToggleService } from "../../shared/toggle/toggle.service";

@Component({
  selector: "re-user-list",
  templateUrl: "./user-list-legacy.component.html",
  styleUrls: ["./user-list-legacy.component.scss"],
  standalone: false,
})
export class UserListLegacyComponent implements OnInit, OnDestroy {
  users: User[] = [];
  permissions: ResourcePermissions;
  loading: boolean;
  alert: Alert;
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  allowSearch: boolean;
  showMessage = false;
  ssoId: string;
  user: User;
  modalReference: any;
  // hasGlobalError = false;
  messageSubscription: Subscription;
  isAuthenticated: boolean;
  userAction: string;
  userFirstName: string;
  userLastName: string;
  userFederatedId: string;
  userCustomerEmployeeId: string;
  public customerFederationEnabled = false;

  private readonly SuspendedText = "Suspended";
  private readonly DeactivatedText = "Deactivated";
  private readonly PasswordExpiredText = "Password expired";

  statusFilterOptions: string[] = [
    "All",
    "Active",
    this.DeactivatedText,
    this.SuspendedText,
    this.PasswordExpiredText,
    "Pending user action",
    "Password reset",
    "Locked out",
    "Staged",
  ];
  selectedStatusFilter = "All";
  statusUserAccessTypeOptions: Select2Option[] = [];
  selectedUserAccessTypeFilter = "All";

  private nonSearchableChars = /[*\\]/;
  mcNextLink: string;
  statusDropdownOptions: Select2Option[] = this.statusFilterOptions.map((x) => {
    return { id: x, text: x };
  });

  // pagination object
  pagination: any = {};
  // User list items after pagination
  pagedItems: any[];
  entriesPerPage = 25;
  dataTable: DataTables.Api;
  isAdmin$: Observable<boolean>;
  running = false;
  isCorporateLimitedAdmin = false;
  isLocationLimitedAdmin = false;
  isCorporateAdmin = false;
  constructor(
    public userService: UserService,
    private messageService: MessageService,
    private modalService: ModalService,
    private paginationService: PaginationService,
    private router: Router,
    private ngZone: NgZone,
    private securityService: SecurityService,
    private userDetailService: UserDetailService,
    private toggleService: ToggleService,
    private configurationService: ConfigurationService,
    private customerService: CustomerService,
  ) {
    this.firstName = "";
    this.lastName = "";
    this.userName = "";
    this.email = "";
    this.allowSearch = true;

    this.isAdmin$ = this.securityService.isUserManagementCorporateAdmin();
    this.messageSubscription = this.messageService
      .get()
      .subscribe((message) => {
        // TODO: Refactor this with a better approach.
        if (
          message == MessageType.UserCreated ||
          message == MessageType.UserDeleted
        ) {
          this.showMessage = message; // Expected actions ('CREATED' || 'Delete');
          this.userAction = message;
          this.clearAlerts();
        }
      });
  }

  async export() {
    var modal = this.modalService.create<UsersExportDialogComponent>(
      UsersExportDialogComponent,
    );
    let filters: UserExportRequest = {
      firstName: this.firstName,
      lastName: this.lastName,
      search: this.userName,
      status: this.selectedStatusFilter,
      userAccessType: this.selectedUserAccessTypeFilter,
    };
    modal.component.filters = filters;
    var result = await modal.modalRef.result;
    if (result) {
      this.running = true;

      this.userService.exportUsers(filters).subscribe(
        (event) => {
          if (event.type === HttpEventType.DownloadProgress) {
            window.status = `Receiving data ${event.loaded} `; // download percentage
          } else if (event instanceof HttpResponse) {
            this.running = false;
            fileSaver.saveAs(
              event.body,
              getDownloadFileName("Users.csv"),
              event.type,
            );
          }
        },
        (e) => {
          this.running = false;
          this.alert = getAlertMessage(e);
        },
      );
    }
  }
  ngOnDestroy(): void {
    delete window["currentComponent"];
    if (this.dataTable) this.dataTable.destroy();
  }

  navigateToRoute(url: string) {
    this.ngZone.run(() => {
      this.router.navigateByUrl(url);
    });
  }

  private serialize(obj: any) {
    return encodeURIComponent(JSON.stringify(obj));
  }

  private deserialize(text: string): any {
    return JSON.parse(decodeURIComponent(text));
  }

  private showSpinner() {
    this.messageService.send(MessageType.ProcessingOn);
  }

  private async loadDefaultConfigPhysicianFlag() {
    try {
      const crmId = await this.securityService.getCrmId().toPromise();
      if (!crmId) return;
      const configs = await this.customerService.getCustomerConfigurationsByCrmId(crmId).toPromise();
      const configId = configs?.find(x => x.isDefault)?.configId;
      if (configId) {
        this.configurationService.isPhysicianFeatureEnabled(configId.toString()).subscribe({
          next: enabled => { this.isPhysicianFeatureEnabled = enabled; },
          error: error => { this.alert = getAlertMessage(error); }
        });
      }
    } catch (error) {
      this.alert = getAlertMessage(error);
    }
  }

  private hideSpinner() {
    this.messageService.send(MessageType.ProcessingOff);
  }

  isLocationAdmin = false;
  isPhysicianFeatureEnabled = false;
  selectedLocationName = "";
  isSupportUser = false;
  selectedUserType = 'non-physician';
  userTypeOptions: Select2Option[] = [
    { id: 'non-physician', text: 'Non-Provider Users' },
    { id: 'physician', text: 'Physician/NPPA' },
  ];
  async ngOnInit() {
    this.isSupportUser = await firstValueFrom(
      this.securityService.isSupportUser(),
    );
    this.isLocationAdmin = await this.securityService
      .isUserManagementLocalAdmin()
      .toPromise();
    this.isCorporateLimitedAdmin = await firstValueFrom(
      this.securityService.isCorporateLimitedAdmin(),
    );
    this.isLocationLimitedAdmin = await this.securityService
      .isUserLocationLimitedAdmin()
      .toPromise();
    this.isCorporateAdmin = await this.securityService
      .isUserManagementCorporateAdmin()
      .toPromise();

    if (this.isLocationAdmin || this.isLocationLimitedAdmin) {
      try {
        this.showSpinner();

        let options = await this.userDetailService.getOptions().toPromise();

        // Check physician feature flag
        const configId = options?.[0]?.configId;
        if (configId) {
          this.configurationService.isPhysicianFeatureEnabled(configId).subscribe(enabled => {
            this.isPhysicianFeatureEnabled = enabled;
          });
        }

        // Populate location options
        let facilities = new Array<UserDetailOptionsFacility>();

        options
          .map((x) => x.facilities)
          .forEach((corpFacilities) => {
            corpFacilities.forEach((facility) => {
              facilities.push(facility);
            });
          });

        this.locationOptions = facilities.map<Select2Option>((x) => ({
          id: x.name,
          text: x.name,
        }));
        // if(this.isCorporateAdmin) {
        //   this.locationOptions.unshift({ id: ' ', text: 'Not Selected' });
        // }
        if (this.locationOptions.length > 0) {
          this.selectedLocation = this.locationOptions[0].id;
          this.selectedLocationName = this.locationOptions[0].text;
        }
      } catch (e) {
        this.alert = getAlertMessage(e);
      } finally {
        this.hideSpinner();
      }
    } else if (this.isCorporateAdmin || this.isCorporateLimitedAdmin) {
      // /referenceData never populates isDefaultConfig; use the /configurations summary endpoint which always computes the true default.
      // Not awaited so it doesn't block status/grid initialization below.
      this.loadDefaultConfigPhysicianFlag();
    }

    const toggles = await this.toggleService.get().toPromise();
    this.customerFederationEnabled = toggles.azureADEnabled;

    // Populate statusUserAccessTypeOptions
    const accessTypes = await this.userService.getUserAccessTypes();
    this.statusUserAccessTypeOptions = Object.entries(accessTypes).map(
      ([key, value]) => ({
        id: key,
        text: value,
      }),
    );
    this.statusUserAccessTypeOptions.push({ id: "All", text: "All" });

    window["currentComponent"] = this;
    let myTableColumns = [
      {
        className: "",
        title: "First Name",
        render: (data: any, type: any, u: User) => {
          return `<a href='javascript:currentComponent.navigateToRoute("/user/${u.ssoid}")'><img style='display:${u.federatedIdentity ? "" : "none"}' class='pr-2' data-toggle="tooltip" data-placement="right" title='Federated User' src='assets/images/Federated User Icon.svg'>${u.firstName}</a>`;
        },
      },
      {
        className: "",
        title: "Last Name",
        render: (data: any, type: any, u: User) => {
          return `<a href='javascript:currentComponent.navigateToRoute("/user/${u.ssoid}")'>${u.lastName}</a>`;
        },
      },
      {
        title: "Emp. Id",
        render: (data: any, type: any, u: User) => {
          return `${u.customerEmployeeId ? u.customerEmployeeId : ""}`;
        },
      },
      { data: "userName", title: "Username" },
      {
        title: "E-mail",
        render: (data: any, type: any, u: User) => {
          return `${this.userService.isDummyEmail(u.email) ? "" : u.email}`;
        },
      },
      {
        title: "IDM User Admin Access",
        render: (data: any, type: any, u: User) => {
          return `${this.userService.getUserAccesText(u.adminToolRole)}`;
        },
      },
      {
        title: "Status",
        render: (data: any, type: any, u: User) => {
          let statusBadge = this.getStatusBadge(u);
          let html = ``;
          if (statusBadge) {
            html += `<span class="${statusBadge}"><span class="m-lg-2">${u.status}</span></span>`;
          } else {
            html += u.status;
          }

          return html;
        },
      },
      {
        title: "Actions",
        visible: !this.isSupportUser,
        className: "actionsCell",
        render: (data: any, type: any, u: User) => {
          let html = `<span class="dropdown">
<button class="btn btn-link dropdown-toggle p-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
  Actions
</button>

<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">`;

          let serializedUser = this.serialize(u);
          let isCLA = this.isCorporateLimitedAdmin;
          let isLLA = this.isLocationLimitedAdmin;
          if (u.status == "Locked out") {
            html += `<a href="javascript:" class="dropdown-item"  onclick="currentComponent.unlock(currentComponent.deserialize('${serializedUser}'))">Unlock</a>`;
          } else if (isCLA) {
            let html = `<span> No Action available </span>`;
            return html;
          } else if (isLLA) {
            let html = `<span> No Action available </span>`;
            return html;
          }
          if (!isCLA && !isLLA) {
            if (u.status != "Suspended" && u.status != "Deactivated") {
              html += `<a href="javascript:" class="dropdown-item"  onclick="currentComponent.open('Suspend', currentComponent.deserialize('${serializedUser}') )">Suspend</a>`;
            }
            if (
              u.status == "Deactivated" ||
              u.status == "Suspended" ||
              u.status == "Staged"
            ) {
              if (u.deactivationDate) {
                html += `<a href="javascript:" class="dropdown-item"  onclick="currentComponent.open('Activate', currentComponent.deserialize('${serializedUser}'))">Activate</a>`;
              } else {
                html += `<a href="javascript:" class="dropdown-item"  onclick="currentComponent.activate(currentComponent.deserialize('${serializedUser}'),'${u.status}')">Activate</a>`;
              }
            }
            if (u.status != "Deactivated" && this.selectedUserType != 'physician') {
              html += `<a href="javascript:" class="dropdown-item"  onclick="currentComponent.open( 'Deactivate', currentComponent.deserialize('${serializedUser}'))">Deactivate</a>`;
            }
            if (u.status === "Deactivated") {
              html += `<a href="javascript:" class="dropdown-item" onclick="currentComponent.open( 'Delete', currentComponent.deserialize('${serializedUser}') )">Delete</a>`;
            }
          }

          html += "</div></span>";
          return html;
        },
      },
    ];

    if (this.customerFederationEnabled) {
      myTableColumns.splice(3, 0, {
        title: "Fed. Login Id",
        render: (data: any, type: any, u: User) => {
          return `${u.federatedLoginID ? u.federatedLoginID : ""}`;
        },
      });
    }

    this.dataTable = $("#userList").DataTable({
      responsive: false,
      ordering: false,
      searching: false,
      paging: false,
      info: false,
      language: {
        emptyTable: "No Matching Records Found.",
      },
      columns: myTableColumns,
    });

    new $.fn.dataTable["FixedHeader"](this.dataTable);
    this.getUsers();
  }
  getStatusBadge(u: User): string {
    if (u.status === this.SuspendedText) return "badge badge-default";

    if (u.status === this.DeactivatedText) return "badge badge-default";

    if (u.status === this.PasswordExpiredText) return "badge badge-danger";

    return "";
  }

  paginate(page: number) {
    // Get pagination object from  pagination service
    this.pagination = this.paginationService.getPaginationObject(
      this.users.length,
      page,
      this.entriesPerPage,
    );

    // Get current page of user items
    this.pagedItems = this.users.slice(
      this.pagination.startIndex,
      this.pagination.endIndex + 1,
    );
    this.dataTable.clear();
    this.dataTable.rows.add(this.pagedItems);
    this.dataTable.draw();

    // Lets recalculate responsiveness after the data is loaded so columns that don't fit in the viewport will be hidden
    // and moved to the details section.
    this.dataTable["responsive"].rebuild();
    this.dataTable["responsive"].recalc();

    $(".dropdown-toggle")["dropdown"]();
  }

  locationOptions: Select2Option[];

  selectedLocationChanged($event) {
    this.selectedLocationName = this.locationOptions.firstOrDefault(
      (x) => x.id == this.selectedLocation,
    ).text;
    this.load();
  }

  selectedUserTypeChanged($event) {
    this.selectedUserType = $event.id;
  }
  selectedLocation: string = "";

  load() {
    this.dataTable?.search("").draw(); //the search text will be used dataTableBeforeSend
  }

  getCurrentPageSize(): string {
    if (this.entriesPerPage === 99999) {
      return "All";
    } else {
      return this.entriesPerPage.toString();
    }
  }

  updatePageSize(newSize: number) {
    if (this.entriesPerPage !== newSize) {
      this.entriesPerPage = newSize;
    }
    this.paginate(1);
  }

  clearAlerts() {
    this.alert = null;
    setTimeout(() => (this.showMessage = false), 5000);
  }

  listUsersByStatusFilter(statusFilter: Select2Option) {
    this.selectedStatusFilter = statusFilter.id;
    //this.getUsers();
  }

  listUsersByUserAccessTypeFilter(userAccessType: Select2Option) {
    this.selectedUserAccessTypeFilter = userAccessType.id;
  }

  searchUsers() {
    if (this.allowSearch) {
      this.getUsers();
    }
  }

  clearSearch() {
    // clear all search fields
    this.firstName = "";
    this.lastName = "";
    this.userName = "";
    this.email = "";
    this.allowSearch = true;
    this.userFederatedId = "";
    this.userCustomerEmployeeId = "";
    this.selectedStatusFilter = "All";
    this.selectedUserAccessTypeFilter = "All";
    this.selectedUserType = 'non-physician';
    //this.getUsers();
  }

  allowSearchText(searchText: string) {
    return this.nonSearchableChars.test(searchText);
  }

  validateSearchText() {
    this.allowSearch =
      !this.nonSearchableChars.test(this.firstName) &&
      !this.nonSearchableChars.test(this.lastName) &&
      !this.nonSearchableChars.test(this.userName) &&
      !this.nonSearchableChars.test(this.email);

    return this.allowSearch;
  }

  searchInputKeyPress(event: any) {
    const inputChar = String.fromCharCode(event.charCode);

    if (this.nonSearchableChars.test(inputChar)) {
      this.allowSearch = false;
    } else {
      this.validateSearchText();
    }
  }

  open(action, user) {
    this.user = user;
    this.userAction = action;
    this.modalService.openModal(UserListActionsModalComponent);
    this.modalReference = this.modalService.modalRef;
    const component = <UserListActionsModalComponent>(
      this.modalReference.componentInstance
    );
    component.user = this.user;
    component.userAction = this.userAction;
    component.userDetailActionsEvent.subscribe(($action) => {
      this.modalSubmit($action);
    });
  }

  modalSubmit(action) {
    if (action === "Suspend") {
      this.suspend(this.user);
    } else if (action === "Deactivate") {
      this.deactivate(this.user);
    } else if (action === "Delete") {
      this.delete(this.user);
    } else if (action === "Activate") {
      this.activate(this.user, this.user.ssoid);
    }
  }

  updateScreenDelay = 1000;
  suspend(user): void {
    this.user = user;
    this.userFirstName = this.user.firstName;
    this.userLastName = this.user.lastName;
    this.userService.suspend(this.user.ssoid).subscribe(
      (res) => {
        this.modalReference.close();
        this.showMessage = true;
        this.clearAlerts();
        setTimeout(() => {
          this.getUsers();
        }, this.updateScreenDelay);
      },
      (error) => {
        // console.log("error while suspending an user");
        this.alert = getAlertMessage(error);
        this.modalReference.close();
      },
    );
  }

  deactivate(user): void {
    this.user = user;
    this.userFirstName = this.user.firstName;
    this.userLastName = this.user.lastName;
    this.users = [];
    this.userService.deactivate(this.user.ssoid).subscribe(
      (res) => {
        this.modalReference.close();
        this.showMessage = true;
        this.clearAlerts();
        setTimeout(() => {
          this.getUsers();
        }, this.updateScreenDelay);
      },
      (error) => {
        // console.log("error while inactivating an user");
        this.alert = getAlertMessage(error);
        this.modalReference.close();
      },
    );
  }

  delete(user): void {
    this.user = user;
    this.userFirstName = this.user.firstName;
    this.userLastName = this.user.lastName;
    this.users = [];
    this.userService.delete(this.user.ssoid).subscribe(
      (res) => {
        this.modalReference.close();
        this.showMessage = true;
        this.clearAlerts();
        setTimeout(() => {
          this.getUsers();
        }, this.updateScreenDelay);
      },
      (error) => {
        // console.log("error while deleting an user");
        this.alert = getAlertMessage(error);
        this.modalReference.close();
      },
    );
  }

  unlock(user): void {
    this.userAction = "Unlock";
    this.user = user;
    this.userFirstName = this.user.firstName;
    this.userLastName = this.user.lastName;
    this.userService.unlock(this.user.ssoid).subscribe(
      (res) => {
        this.showMessage = true;
        this.clearAlerts();
        setTimeout(() => {
          this.getUsers();
        }, this.updateScreenDelay);
      },
      (error) => {
        // console.log("error while unlocking an user");
        this.alert = getAlertMessage(error);
      },
    );
  }

  activate(user, status: string): void {
    this.userAction = "Activate";
    this.user = user;
    this.userFirstName = this.user.firstName;
    this.userLastName = this.user.lastName;
    this.users = [];
    this.userService.activate(this.user, status).then(
      (res) => {
        if (res != null) {
          if (this.modalReference) {
            this.modalReference.close();
          }
          this.showMessage = true;
          this.clearAlerts();
          setTimeout(() => {
            this.getUsers();
          }, this.updateScreenDelay);
        }
      },
      (error) => {
        // console.log("error while activating an user");
        this.alert = getAlertMessage(error);
        if (this.modalReference) {
          this.modalReference.close();
        }
      },
    );
  }

  setSearchValues(event: any) {
    // set all values at once
    this.userName =
      this.email =
      this.userFederatedId =
      this.userCustomerEmployeeId =
        event.target.value.trim();
  }

  /**
   * Get users with start index and page size.
   */
  getUsers(): void {
    let params = new HttpParams();
    params = params.set("firstName", this.firstName);
    params = params.set("lastName", this.lastName);
    params = params.set("userName", this.userName);
    params = params.set("email", this.email);
    params = params.set(
      "federatedLoginID",
      this.userFederatedId ? this.userFederatedId : "",
    );
    params = params.set(
      "customerEmployeeId",
      this.userCustomerEmployeeId ? this.userCustomerEmployeeId : "",
    );
    params = params.set(
      "statusFilter",
      this.selectedStatusFilter === "All" ? "" : this.selectedStatusFilter,
    );
    params = params.set(
      "location",
      this.selectedLocationName == "Not Selected"
        ? ""
        : this.selectedLocationName,
    );
    params = params.set(
      "userAccessType",
      this.selectedUserAccessTypeFilter === "All"
        ? ""
        : this.selectedUserAccessTypeFilter,
    );
    params = params.set("includePhysicians", this.selectedUserType === 'physician' ? 'true' : 'false');

    this.loading = true;
    this.users = [];

    // with params
    this.userService.getUsers(params).subscribe(
      (res) => {
        Array.prototype.push.apply(this.users, res.data);

        this.mcNextLink = res.headers.get("mc-next-link");
        this.paginate(1);
        this.loading = false;

        window.scrollTo(0, 0);

        $('[data-toggle="tooltip"]')["tooltip"]();
      },
      (error) => {
        this.alert = getAlertMessage(error);
        this.loading = false;
      },
    );
  }

  /**
   * Get next set of users meeting the original search criteria.
   */
  getNextLinkUsers(page: number): void {
    this.loading = true;

    this.userService.getNextUsers(this.mcNextLink).subscribe(
      (res) => {
        Array.prototype.push.apply(this.users, res.data);

        this.mcNextLink = res.headers.get("mc-next-link");
        this.paginate(page);
        this.loading = false;

        window.scrollTo(0, 0);
      },
      (error) => {
        this.alert = getAlertMessage(error);
        this.loading = false;
      },
    );
  }

  paginateNext(page: number) {
    // Determine if the next set of records meeting the search criteria need to be retrieved.
    if (this.pagination.currentPage === this.pagination.totalPages) {
      this.getNextLinkUsers(page);
    } else {
      this.paginate(page);
    }
  }
}
